import { makeStyles } from '@material-ui/core';

import { redColor } from 'core/ui/Colors';

export const useStyles = makeStyles({
  container: {
    position: 'relative',
    backgroundColor: '#404041',
    paddingBottom: 16,
  },
  contentContainerStyle: {
    padding: '24px 262px', // 262px = 250px(left drawer when open) + 12px
    display: 'flex',
    flexDirection: 'row',
    gap: 32,
  },
  itemWrapper: {
    position: 'relative',
  },
  removeButton: {
    position: 'absolute',
    top: 4,
    left: 4,
    zIndex: 100,
    color: redColor,
  },
  absoluteLoader: {
    position: 'absolute',
    top: 16,
    left: 2,
  },
  listEmptyComponent: {
    display: 'flex',
    flex: 1,
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  listEmptyComponentLoader: {
    color: 'white',
  },
  listEmptyComponentText: {
    color: 'white',
    textAlign: 'center',
  },
});
